import { dataHooks } from '../../../../libs/dataHooks';

export const forYouGenericPageDataHooks = dataHooks<{
  section: { name: string };
  sectionTemplates: { name: string };
  sectionCategoriesList;
}>('forYouGenericPage');
